module.exports = " <div class=\"content\"> <product-categories-cmp [catalogState]=\"_appService.state.catalog\" [scrollContainerElem]=\"catalogElem\" (categorySelected)=\"_appCatalogService.selectCategory( $event )\"> </product-categories-cmp> <div class=\"summary-link-div\"> <div class=\"button big arrow\" id=\"summary-link\" (click)=\"_navigationService.openSummaryPage()\"> View Summary </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/catalog/pages/catalog.cmp.html
// module id = 843
// module chunks = 1